import { GiftSubmission } from "creso-core/types";

/** Most recently created gift-city-form submission matching `filter`. */
export function getLatestGiftSubmission(
  submissions: GiftSubmission[] | undefined,
  filter: (submission: GiftSubmission) => boolean = () => true
): GiftSubmission | undefined {
  return submissions
    ?.filter(filter)
    .sort(
      (a, b) =>
        new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
    )
    .pop();
}

/** Last path segment of a file URL, e.g. ".../pan/2026/06/13/PanCard.PNG" → "PanCard.PNG" */
export function fileNameFromUrl(url: string | null | undefined): string | null {
  if (!url) return null;
  try {
    const name = new URL(url, window.location.origin).pathname.split("/").pop();
    return name ? decodeURIComponent(name) : null;
  } catch {
    return null;
  }
}
